export default __webpack_public_path__ + "static/media/definix-overview.ad267c1d.png";